import { Ecc, QrCode, QrSegment } from "./qrcodegen-v1.8.0";
import getMode from "../tools/getMode";
import modes from "../constants/modes";

export const qrcode = (typeNumber: number, errorCorrectionLevel: string) => {
  const _state: { qr: QrCode, typeNumber, errorCorrectionLevel?: Ecc, text: string } = {
    typeNumber: typeNumber > 0 ? typeNumber : undefined,
    errorCorrectionLevel: getEcc(errorCorrectionLevel),
    qr: null,
    text: null
  };

  return {
    getModuleCount: () => {
      return _state.qr.size;
    },
    addData: (data) => {
      _state.text = data;
    },
    isDark: (x, y) => {
      return _state.qr.getModule(x, y);
    },
    make: () => {
      const mode = getMode(_state.text);

      // console.log(`make ${mode} from ${_state.text} ecl ${_state.errorCorrectionLevel} version ${_state.typeNumber}`);
      let segment;
      try {
        switch (mode) {
          case modes.byte: {
            // var array = String.fromCharCode.apply(null, _state.text);
            // const array = stringToUint(_state.text);
            const array = new TextEncoder().encode(_state.text)
            segment = QrSegment.makeBytes(array);
            break;
          }
          case modes.alphanumeric:
          default: {
            segment = QrSegment.makeAlphanumeric(_state.text as string);
            break;
          }
        }
      } catch (e) {
        throw new Error(`Error making QR segment: ${e.message}`)
      }

      // console.log("segment", segment);
      try {
        _state.qr = QrCode.encodeSegments([segment], _state.errorCorrectionLevel, _state.typeNumber, _state.typeNumber);
      } catch (e) {
        throw new Error(`Error encoding QR segment: ${e.message}`)

      }
    }
  }
}

export const getEcc = (eccString: string) => {
  switch (eccString.toLowerCase()) {
    case "l": return Ecc.LOW;
    case "h": return Ecc.HIGH;
    case "m": return Ecc.MEDIUM;
    case "q": return Ecc.QUARTILE;
    default: throw new Error(`bad ecc string: ${eccString}`)
  }
}
